import { Navigate, Outlet } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute() {
  const { user, booted } = useAuth();

  if (!booted) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white" data-testid="auth-loading">
        <Loader2 className="h-6 w-6 animate-spin text-brand" />
      </div>
    );
  }
  if (!user) return <Navigate to="/crm/login" replace />;
  return <Outlet />;
}
